import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appBreadcrumb from './app-breadcrumb'
import appConfig from './app-config'
import auth from './auth'
import verticalMenu from './vertical-menu'
import userProfile from './user-profile'
import organisationDetailsModal from './organisation-details-modal'
import groupDetailsModal from './group-details-modal'
import userDetailsModal from './user-details-modal'
import search from './search'
import homeAddNew from './home-add-new'
import home from './home'
import organisation from './organisation'
import group from './group'
import content from '@/store/content'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appBreadcrumb,
    appConfig,
    auth,
    verticalMenu,
    userProfile,
    organisationDetailsModal,
    groupDetailsModal,
    userDetailsModal,
    search,
    home,
    homeAddNew,
    organisation,
    group,
    content
  },
  strict: process.env.DEV
})
